export default __webpack_public_path__ + "static/media/Gaz.91b9e625.svg";